/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";
import HomeIcon from "@material-ui/icons/Home";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import LocalMallOutlinedIcon from "@material-ui/icons/LocalMallOutlined";
import { NavbarLink } from "./components/NavbarLink/navbar-link";
import "./styles.scss";
import { igemLogoDark } from "../../assets/icons";

const links = [
  { title: "Home", to: "/", inMainMenu: false, color: "#40CC7F" },
  { title: "Lineup", to: "/lineup", inMainMenu: true, color: "#f8ed6e" },
  { title: "Videos", to: "/videos", inMainMenu: true, color: "#d658bb" },
  { title: "Teams", to: "/teams", inMainMenu: true, color: "#09C6C6" },
  { title: "People", to: "/people", inMainMenu: true, color: "#F59B55" },
 { title: "Sponsors", to: "/sponsors", inMainMenu: true, color: "#f8ed6e" },
];

export const Navbar = (): JSX.Element => {
  const { pathname } = useLocation();
  const [activeTab, setActiveTab] = React.useState(
    links.find((link) => link.to === pathname)?.title
  );
  const [lineParameters, setLineParameters] = React.useState({
    left: 0,
    width: 0,
  });
  const [mobileMenuActive, setMobileMenuActive] = React.useState(false);

  const changeTab = (link: string) => {
    setActiveTab(link);
    setMobileMenuActive(false);
  };
  useEffect(() => {
    setActiveTab(links.find((link) => link.to === pathname)?.title);
  }, [pathname]);

  const positionLineElement = () => {
    const activeElement = document.querySelector(".navbar .active");
    const style = activeElement?.getBoundingClientRect();
    if (style) {
      setLineParameters({
        left: style.left - 20,
        width: style.width,
      });
    }
  };
  const [width, setWidth] = useState<number>(window.innerWidth);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
    positionLineElement();
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, [width]);
  const isMobile: boolean = width <= 667;

  React.useEffect(() => {
    positionLineElement();
  }, [activeTab]);

  return (
    <>
      <div className="navbar">
        <div className="navbar-wrapper">
          <div>
            <ul className="navbar-list-left">
              <li>
                <a href="https://igem.org" target="_blank" rel="noreferrer">
                  <img src={igemLogoDark} alt="igem-logo" />
                </a>
              </li>
              {!isMobile && (
                <>
                  <li
                    className={clsx(
                      "navbar-link",
                      activeTab === "Home" && "active"
                    )}
                  >
                    <Link
                      to="/"
                      onClick={() => changeTab("Home")}
                      style={{
                        color:
                          activeTab === "Home"
                            ? links.find((link) => link.title === activeTab)
                                ?.color
                            : undefined,
                      }}
                    >
                      <HomeIcon />
                    </Link>
                  </li>
                  
                </>
              )}
            </ul>
            {!isMobile && (
              <ul>
                {links
                  .filter((link) => link.inMainMenu)
                  .map((link) => (
                    <NavbarLink
                      key={link.title}
                      title={link.title}
                      isActive={link.title === activeTab}
                      changeTab={changeTab}
                      to={link.to}
                      color={link.color}
                      likeButton={link.title === "RSVP"}
                    />
                  ))}
         <li
                    className={clsx(
                      "merch-link",
                      "navbar-link",
                      activeTab === "Merch" && "active"
                    )}
                  >
                    <a
            href="https://merch.igem.io"
            target="_blank" rel="noreferrer"
            
                    >
                      <LocalMallOutlinedIcon />
                      <h6>Merch</h6>
                    </a>
                  </li>
              </ul>
            )}
            {isMobile && (
              <button
                type="button"
                className="menu-icon"
                onClick={() => setMobileMenuActive(true)}
              >
                <MenuIcon />
              </button>
            )}
          </div>
          {!isMobile && (
            <div
              className="navbar__line"
              style={{
                left: lineParameters.left,
                width: lineParameters.width,
                backgroundColor: links.find((link) => link.title === activeTab)
                  ?.color,
              }}
            />
          )}
        </div>
      </div>
      {isMobile && (
        <div className={clsx("navbar-mobile", mobileMenuActive && "active")}>
          <button type="button" onClick={() => setMobileMenuActive(false)}>
            <CloseIcon />
          </button>

          <ul>
            {links.map((link) => (
              <NavbarLink
                key={link.title}
                title={link.title}
                isActive={link.title === activeTab}
                changeTab={changeTab}
                to={link.to}
                color={link.color}
                likeButton={link.title === "RSVP"}
              />
            ))}
       <button
      type="button"
      className={clsx("navbar-link")}
    >
      <a href="https://merch.igem.io" target="_blank" rel="noreferrer">
        <h6>
          Merch
        </h6>
      </a>
    </button>
          </ul>
        </div>
      )}
    </>
  );
};
